import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { apiProviders } from './api.provider';
import { reportRepositoryProvider } from './repositories';
export var ReportRepositoryWebModule = /*#__PURE__*/function () {
  function ReportRepositoryWebModule() {
    _classCallCheck(this, ReportRepositoryWebModule);
  }

  _createClass(ReportRepositoryWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: ReportRepositoryWebModule,
        providers: [{
          provide: 'REPORT_REPOSITORY_WEB_CONFIG',
          useValue: config
        }].concat(_toConsumableArray(apiProviders), [reportRepositoryProvider]),
        exports: [reportRepositoryProvider]
      };
    }
  }]);

  return ReportRepositoryWebModule;
}();